"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NETWORK_HEALTH_POOR = exports.NETWORK_HEALTH_GOOD = exports.NETWORK_HEALTH_EXCELLENT = void 0;
var NETWORK_HEALTH_POOR = exports.NETWORK_HEALTH_POOR = 'poor';
var NETWORK_HEALTH_GOOD = exports.NETWORK_HEALTH_GOOD = 'good';
var NETWORK_HEALTH_EXCELLENT = exports.NETWORK_HEALTH_EXCELLENT = 'excellent';